/* (ignored) */


//////////////////
// WEBPACK FOOTER
// vertx (ignored)
// module id = 12
// module chunks = 0